// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "select[data-v-9d15e8e6]{color:#cfd0cf}select.has-selection[data-v-9d15e8e6]{color:#000}", ""]);
// Exports
module.exports = exports;
